import { render, staticRenderFns } from "./flowBranch.vue?vue&type=template&id=5ea2bf88&scoped=true"
import script from "./flowBranch.vue?vue&type=script&lang=js"
export * from "./flowBranch.vue?vue&type=script&lang=js"
import style0 from "./flowBranch.vue?vue&type=style&index=0&id=5ea2bf88&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2bf88",
  null
  
)

export default component.exports